import { NgModule } from '@angular/core';

/**
 * Kept for backward compatibility with module-based features that
 * import this module. The dialog component is now standalone and is opened
 * dynamically by ConfirmationDialogService, so no imports / declarations are
 * needed here.
 *
 *  TODO: Remove this module and update imports in features that use confirmation dialogs to import the dialog component directly
 *
 */
@NgModule({})
export class ConfirmationDialogModule {}
